app.factory("SyllabusParser", ["$log",
    function ($log) {
        var SyllabusParser = {};

        function getPart(part, key) {
            var afterName = part.substring(part.indexOf(key) + key.length);
            var nameStart = afterName.indexOf('\n');
            afterName = afterName.substring(nameStart + 1);
            var nameEnd = afterName.indexOf('\n');
            return afterName.substring(0, nameEnd);
        }

        function removeLine(part) {
            return part.substring(part.indexOf('\n') + 1);
        }

        SyllabusParser.parseSyllabus = function (contents) {
            var syllabus = {subject: {}, lecturer: {}};
            for (var i = 1; i < 13; i++) {
                var start = contents.indexOf(i + '. ');
                var end = contents.indexOf((i + 1) + '. ');
                var part = contents.substr(start, end - start);
                partsProcessor[i](syllabus, part);
            }
            return syllabus;
        };

        var partsProcessor = {
            1: function (syllabus, part) {
                syllabus.subject.subjectName = getPart(part, 'სასწავლო კურსის სახელწოდება');
                syllabus.subject.credits = getPart(part, 'კრედიტების რაოდენობა');
                syllabus.subject.programName = getPart(part, 'საგანმანათლებლო პროგრამა');
                syllabus.subject.level = getPart(part, 'სწავლების საფეხური');
            },
            2: function (syllabus, part) {
                syllabus.lecturer.name = getPart(part, 'სახელი, გვარი');
                syllabus.lecturer.position = getPart(part, 'თანამდებობა');
                syllabus.lecturer.phone = getPart(part, 'ტელეფონი');
                syllabus.lecturer.email = getPart(part, 'ელ–ფოსტა');
            },
            3: function (syllabus, part) {
                syllabus.lectureTime = getPart(part, 'ლექცია');
                syllabus.seminarTime = getPart(part, 'სემინარი');
                syllabus.laboratoryTime = getPart(part, 'ლაბორატორიული სამუშაო');
                syllabus.quizzes = getPart(part, 'შუალედური გამოცდა');
                syllabus.exam = getPart(part, 'დასკვნითი გამოცდა');
                syllabus.homework = getPart(part, 'დამოუკიდებელი მუშაობა');
            },
            4: function (syllabus, part) {
                syllabus.prerequisites = removeLine(part);
            },
            5: function (syllabus, part) {
                syllabus.goal = removeLine(part);
            },
            6: function (syllabus, part) {

            },
            7: function (syllabus, part) {

            },
            8: function (syllabus, part) {

            },
            9: function (syllabus, part) {

            },
            10: function (syllabus, part) {

            },
            11: function (syllabus, part) {

            },
            12: function (syllabus, part) {

            },
            13: function (syllabus, part) {

            }
        };


        return SyllabusParser;
    }
])
;